<template><div><h1 id="xml-editierbare-felder" tabindex="-1"><a class="header-anchor" href="#xml-editierbare-felder"><span>XML, editierbare Felder</span></a></h1>
<p>XML, editierbare Felder — Festlegung der variablen Felder für Dokumente</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die editierbaren Felder ermöglichen eine Zuordnung von XML-Output-Texten und Bildern zu Tags im XML-Output-File.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Document Output → Dokumente</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Bereich</dt>
<dd>Bezeichnung im Tag des Dokumentes</dd>
<dt>Typ</dt>
<dd>Art der Referenz, &quot;Text&quot; oder &quot;Bild&quot; gem. der Tabelle <a class="link" href="ft.refdata.do-text.html" title="Text- und Bildelemente">Text- und Bildelemente</a>.</dd>
<dt>Referenz</dt>
<dd>Referenz-Wert, Z.B. Textnummer oder Links, siehe oben.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">Document Output</RouteLink></p>
</div></template>


